<template>
  <div class="modal" v-if="seen">
    <div class="renamefile">
      <div class="rename-header d-flex flex-row justify-content-between align-items-center">
        <h3>Rename File</h3>
        <span @click="closebox" class="rename-closefile">
          <img src="@/assets/search-icons/Close.svg" />
        </span>
      </div>
      <div class="inputbox">
        <input type="text" v-model="name" ref="file" placeholder="File Name" @keypress="enterKey" />
        <span class="error" v-if="error">*Required</span>
        <span v-if="found">A file named <strong class="error">{{ name }}</strong> already exist</span>
        <span class="error" v-if="specialChar_error">
          {{ specialChar_error }}
        </span>
      </div>
      <div class="rename-save d-flex justify-content-end">
        <svg v-if="loader" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100"
          width="40px" height="40px" class="lds-dual-ring" style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;">
          <circle cx="50" cy="50" fill="none" stroke-linecap="round" stroke="#039aed" r="30"
            stroke-dasharray="41.41592653589793 41.41592653589793" stroke-width="8">
            <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
              keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
          </circle>
        </svg>
        <span @click="save">Save New Name</span>
      </div>
    </div>
  </div>
</template>
<style>
.modal div.renamefile div {
  margin-top: 0 !important;
  width: 100%;
}

.modal div.renamefile {
  padding: 24px !important;
}

.renamefile input {
  background: transparent !important;
  box-shadow: none !important;
  border: 1px solid #A7B9CB !important;
  padding: 8px 6px;
}

.rename-closefile {
  background: #F2F7FC;
  border-radius: 50%;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.modal div.renamefile .rename-save {
  margin-top: 16px !important;
}

.modal div.renamefile .inputbox {
  margin-top: 16px !important;
}

.rename-save span {
  background: #3F96D1;
  color: #fff;
  border-radius: 6px;
  height: 44px;
  width: 150px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
}
</style>
<script>
import { mapMutations } from 'vuex'
import cookies from '@/services/cookies'

export default {
  data() {
    return {
      name: '',
      seen: false,
      index: null,
      loader: false,
      error: false,
      id: null,
      found: false,
      base: false,
      specialChar_error: false
    }
  },
  methods: {
    ...mapMutations([
      'EMPTY_FILE_ACTION'
    ]),
    logincall() {
      this.$parent.logincall()
    },
    rename(index, name, id, base = false) {
      this.name = name
      this.seen = true
      this.index = index
      this.error = false
      this.loader = false
      this.found = false
      this.id = id
      this.base = base
      this.specialChar_error = false

      this.$nextTick(() => this.$refs.file.focus())

      this.$refs.file.focus()
    },
    specialChar(str) {
      let specialChars = '<>*?:|"\\/';
      let found = "";
      for (let i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          found += specialChars[i];
        }
      }
      return found;
    },
    enterKey(evt) {
      if (evt.keyCode == 13) {
        if (this.specialChar(this.name)) {
          this.specialChar_error =
            this.specialChar(this.name) + " are not allowed";
          return;
        }

        if (this.name === '') {
          this.error = true
        } else {
          this.error = false
          this.loader = true
          this.found = false

          let that = this
          let data = {
            token: cookies.getCookie('token'),
            new_name: this.name,
            file_id: this.id
          }

          this.$socket.emit('renamefile', data, function (data) {
            if (data.data === true) {
              if (data.found == 0) {
                that.loader = false
                that.$store.getters.DIRECTORY_CHILDREN[that.index].dir = that.name
                that.seen = false

                if (that.base === true) {
                  let index = that.$store.getters.GET_FILES_INDEX[that.$store.getters.GET_FILE_ACTION[0]]
                  let name = that.$store.getters.DIRECTORY_CHILDREN[index].is_checked = false

                  that.EMPTY_FILE_ACTION()
                }
              } else {
                that.found = true
                that.loader = false
              }
            }

            if (data.data === false) {
              that.seen = false
              that.logincall()
              that.$router.push('/login')
            }
          });
        }
      }
    },
    save() {
      if (this.name === '') {
        this.error = true
      } else {
        this.error = false
        this.loader = true
        this.found = false

        let that = this
        let data = {
          token: cookies.getCookie('token'),
          new_name: this.name,
          file_id: this.id
        }

        this.$socket.emit('renamefile', data, function (data) {
          if (data.data === true) {
            if (data.found == 0) {
              that.loader = false
              that.$store.getters.DIRECTORY_CHILDREN[that.index].dir = that.name
              that.seen = false

              if (that.base === true) {
                let index = that.$store.getters.GET_FILES_INDEX[that.$store.getters.GET_FILE_ACTION[0]]
                let name = that.$store.getters.DIRECTORY_CHILDREN[index].is_checked = false

                that.EMPTY_FILE_ACTION()
              }
            } else {
              that.found = true
              that.loader = false
            }
          }

          if (data.data === false) {
            that.seen = false
            that.logincall()
            that.$router.push('/login')
          }
        });
      }
    },
    closebox() {
      this.seen = false
    }
  }
}
</script>
